import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentMethod } from '../models/payment-method.model';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodService {

  constructor(private httpClient: HttpClient) { }

  getPaymentMethods() : Observable<PaymentMethod[]> {
    return this.httpClient.get<PaymentMethod[]>('assets/components/payment-methods/payment-methods.json').pipe(
      map(data => data)
    );
  }
}
